import {  KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup,  NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ContactsService } from '../../Services/contacts.service';
import { Subject } from 'rxjs';
import {  PafLabelDirective } from '../../Directives/paf-label/paflabel.directive';
import { Contact,Civility, ExtUser, IntUser} from '../../all-models';
import { SharedDataService } from '../../Services/shared-data/shared-data.service';
import { IntUsersService } from '../../Services/int-users.service';
import {ExtUsersService} from '../../Services/ext-users.service';

@Component({
  selector: 'contact-row',
  templateUrl: './contact-row.component.html',
  styleUrls: ['./contact-row.component.scss']
})
export class ContactRowComponent implements OnInit, OnChanges {

  private pafLabels: PafLabelDirective = null;
  @Input() showErrors: Subject<boolean>;
  @Input() contact?:Contact = null;
  @Output() contactChange:EventEmitter<Contact> = new EventEmitter<Contact>();
  @Input() disabled?: boolean = false;

  @Input() onlyIntUsers:boolean=false;
  @Input() onlyExtUsers:boolean=false;
  

  @Output() ContactRowValidChange: EventEmitter<KeyValue<Contact, boolean>> = new EventEmitter<KeyValue<Contact, boolean>>();
  @Output() updateContact: EventEmitter<Contact> = new EventEmitter<Contact>();
  editActivated: boolean = false;

  intUsers:IntUser[]=[];
  extUsers:ExtUser[]=[];


  private _intUserSel?:IntUser=null;
  get intUserSel():IntUser{
    return this._intUserSel;
  }
  set intUserSel(value:IntUser){
    this._intUserSel = value;
    if (value){
      this.contact = value?.Contact|| new Contact();
      this.contactChange.emit(this.contact);
    }
  }
  extUserSel?: ExtUser = null;
  @ViewChild('contactRowForm') public contactRowForm: NgForm;
  @ViewChild('contactRowForm') public FrmContactRow: FormGroup;
  constructor(
    public sharedDataSvc: SharedDataService,
    private contactsSvc:ContactsService,
    private intUsersSvc:IntUsersService,
    private extUsersSvc:ExtUsersService,
    public route: ActivatedRoute) {
    this.pafLabels = new PafLabelDirective(this.sharedDataSvc, this.route, null);

  }
  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes['disabled']){
      this.editActivated = false;
    }
    if (changes['onlyIntUsers']){
      if (this.onlyIntUsers){
        this.onlyExtUsers = false;
        if (this.intUsers.length==0) this.loadIntUsers();
      }
    }
    if (changes['onlyExtUsers']){
      if (this.onlyExtUsers){
        this.onlyIntUsers = false;
        if (this.extUsers.length==0) this.loadextUsers();
      }
    }
    if (changes['contact'] && this.contact){
      if (!this.contact.Civility){
        this.contact.Civility = new Civility();
        this.contact.Civility.Id = this.contact.CivId;
      }
      if (this.onlyIntUsers){
        this.intUserSel = this.intUsers.find(u=>u.ContactId==this.contact?.Id);
      }
    }
  }

  displayMail(item:any): string{
    if (!item || !item.Contact) {
      return "";
    }
    return item.Contact.EmailDiff || item.Contact.Email;
  }
  displayName(item:any):string{
    if (!item || !item.Contact) {
      return "";
    }
    return item.Contact.Firstname + ' ' + item.Contact.Lastname;
  }

  
  loadIntUsers():void{
    this.intUsersSvc.IntUsers()
    .subscribe((response:IntUser[])=>{
      this.intUsers=response;
      this.intUsers.forEach(e=>{
        (<any>e).displayName=this.displayName(e);
        (<any>e).displayMail=this.displayMail(e);
      });
      this.intUsersFiltered = this.intUsers;
      if (this.contact){
        this.intUserSel = this.intUsers.find(u=>u.ContactId==this.contact?.Id);
      }
    });
  }

  intUsersFiltered:IntUser[];
  intUsersFilterChange(searchmask: any): void {
    if (!searchmask) {
      this.intUsersFiltered= this.intUsers;
    } else  {
      searchmask = searchmask.removeAccents().toLowerCase();
      this.intUsersFiltered = this.intUsers
      .filter((u:any)=>{
            return ((u.displayMail && u.displayMail.toLowerCase().removeAccents().indexOf(searchmask)>=0)
            || (u.displayName && u.displayName.toLowerCase().removeAccents().indexOf(searchmask)>=0));   
        });
    }
  }

  loadextUsers():void {
    this.extUsersSvc.getExtUsers()
    .subscribe(res=>this.extUsers=res);
  }
  
  ngOnInit(): void {
    if (this.showErrors) this.showErrors.subscribe(v => this.updateValidity());
      setTimeout((): void => {
        this.FrmContactRow.statusChanges.subscribe(res => this.onFormStatutChange());
      }, 0);
  }

  public get civility(): Civility {
    return this.contact ? this.contact.Civility : null;
  }
  public set civility(value: Civility) {
    if (this.contact) {
      this.contact.Civility = value;
      this.contact.CivId = value ? value.Id : 1;
    }
  }
  
  get civilityCod(): string {
    return this.civility ? this.civility.Cod : null;
  }

  
  onFormStatutChange():void {
    if (this.FrmContactRow.status == 'INVALID') {
      this.ContactRowValidChange.emit({ key: this.contact, value: false });
    } else {
      this.ContactRowValidChange.emit({ key: this.contact, value: true });
    }
  }

  updateValidity():void{
      Object.keys(this.FrmContactRow.controls).forEach((key, i) => {
        let control: AbstractControl = this.FrmContactRow.controls[key];
        control.markAsTouched();
      });
  }
  
  update(): void {
    if (!this.sharedDataSvc.CanSave(this.contactRowForm)) return;
    this.updateContact.emit(this.contact);
    this.editActivated = false;
  }

  clear(): void {
    if (!this.FrmContactRow) return;
    Object.keys(this.FrmContactRow.controls).forEach((key, i) => {
      let control: AbstractControl = this.FrmContactRow.controls[key];
      control.setValue('');
      control.setErrors(null);
    });
  }

  public contactBackup: Contact = null;
  public civilityBackup: Civility = null;
  edit(): void {
    this.contactBackup = Object.assign({}, this.contact);
    this.civilityBackup = Object.assign({}, this.civility);
    this.editActivated = true;
  }
  undo(): void {
    this.contact = Object.assign({}, this.contactBackup);
    this.civility = Object.assign({}, this.civilityBackup);
    this.editActivated = false;
  }
  
  get contactDejaExistant(): Contact {
    return this.contactRowForm
      && this.contactRowForm.controls['Email']
      && this.contactRowForm.controls['Email'].errors
      && this.contactRowForm.controls['Email'].errors['emailUnique'];
  }

}
